import React from 'react';
import Modal from './Modal';
import { AlertCircle } from 'lucide-react';
import ErrorMessage from '../ErrorMessage';

interface DeleteModelProp {
  modelType?: 'delete' | 'update';
  show: boolean;
  type?: string;
  onClose: () => void;
  onConfirm: () => void;
  warning?: string;
  subTitle?: string;
}

const ConfirmationModel: React.FC<DeleteModelProp> = ({
  show = false,
  type,
  onClose,
  onConfirm,
  modelType = 'delete',
  subTitle = 'You want to delete this',
  warning,
}) => {
  return (
    <Modal show={show} onClose={onClose} height="max-h-[380px]">
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-yellow-100 p-4 rounded-full">
            {<AlertCircle className="text-red-600 w-10 h-10" />}
          </div>
        </div>
        <h2 className="text-lg font-semibold text-gray-900">Are you sure?</h2>
        <p className="text-gray-500 mt-1">
          {subTitle} {type}?
        </p>
        {warning && <ErrorMessage message={warning} className="mt-3" />}
        <div className="flex justify-between mt-6">
          <button
            onClick={onClose}
            className="w-[48%] bg-gray-200 text-gray-700 font-medium py-2 rounded-lg hover:bg-gray-300 transition"
            // disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="w-[48%] btn-primary flex items-center gap-2"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {modelType === 'delete' ? 'Delete' : 'Update'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModel;
